<template>
  <qx-card title="订单ETC记录">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section v-if="scope.column.property === 'orderId'">
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section v-if="scope.column.property !== 'orderId'">
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableSetting from 'components/tableSetting/tableSetting';
import {
  etcOrderList,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'orderId', label: '订单号码', fixed: true },
          { prop: 'customName', label: '客户简称' },
          { prop: 'sourceName', label: '线路' },
          { prop: 'plateNumber', label: '车牌号' },
          { prop: 'vehicleInfo', label: '车型' },
          { prop: 'carDriverMan', label: '司机' },
          { prop: 'carDriverPhone', label: '司机手机' },
          { prop: 'targetDependTime', label: '发车时间' },
          { prop: 'carArriveDate', label: '到达时间' },
          { prop: 'pontageActual', label: 'ETC消费合计' },
          { prop: 'preEtcFee', label: '预估ETC金额' },
          { prop: 'diffActual', label: '差额' },
          { prop: 'diffActuals', label: '差额比率(%)' },
          { prop: 'mileageNumber', label: '客户公里数' },
          { prop: 'singleKilometer', label: '实际单公里路桥费' },
          { prop: 'paymentWay', label: '成本模式' },
          { prop: 'vehicleClass', label: '车辆种类' },
          { prop: 'reportAmt', label: '费用上报' },
          { prop: 'preTotalFee', label: '预付款(元)' },
          { prop: 'arrivePaymentFee', label: '到付款(元)' },
          { prop: 'finalFee', label: '尾款(元)' },
          { prop: 'goodsName', label: '货物信息' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: etcOrderList,
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
